module.exports = __webpack_public_path__ + "img/O que  não fazer com restos de poda 1.14d09453.webp";